<template>
  <!-- <v-layout row>
    <v-flex xs12 sm12> -->
  <v-card height="100%" v-if="returnedInvoices ? !!invoiceList.length : true">
    <v-card-title class="primary white--text">
      <h3 color="primary">{{ header }}</h3>
      <v-spacer />
      <v-btn
        id="delete-user-btn"
        @click="deleteUser()"
        outlined
        class="primary--text"
        v-if="
          selectedBuyer &&
          header == 'TRANSACTION OPEN' &&
          invoiceList.length == 0 &&
          !getBalance
        "
      >
        <v-icon left> delete </v-icon>
        <b>Delete Account</b>
      </v-btn>
      <router-link
        style="text-decoration: none"
        v-if="selectedBuyer && header == 'TRANSACTION OPEN'"
        :to="{
          name: 'RemainingBalance',
          params: {
            customerId: selectedBuyer,
          },
        }"
      >
        <v-btn outlined>
          <b class="primary--text">Balance:</b>
          <b class="primary--text font-weight-bolder">
            &nbsp;{{ getBalance | amount }}
          </b>
        </v-btn>
      </router-link>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="invoiceList"
        hide-actions
        class="elevation-1"
      >
        <template slot="items" slot-scope="props" class="test__">
          <tr
            :class="[
              props.item.isUnpicked ? 'isUnpicked' : '',
              Number.parseFloat(props.item.totalAmount) <
                Number.parseFloat(props.item.absoluteValue) &&
              (status === 'due' || status === 'partial')
                ? 'absoluteMore'
                : '',
            ]"
          >
            <td class="justify-center layout px-0">
              <!-- Action menu for Tranction operations -->
              <v-menu bottom right offset-y :close-on-content-click="false">
                <v-btn class="mx-0" slot="activator" icon dark>
                  <v-icon color="primary">more_vert</v-icon>
                </v-btn>
                <v-list>
                  <!-- edit invoice btn -->
                  <v-list-tile
                    :disabled="!hasInvoiceEditPermission"
                    v-if="
                      (hasInvoiceEditPermission &&
                        props.item.status == 'due') ||
                      'partial' ||
                      'paid'
                    "
                    @click="editInvoiceModalOpen(props.item)"
                  >
                    <v-list-tile-avatar>
                      <v-icon color="primary">edit</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-title>Edit</v-list-tile-title>
                  </v-list-tile>

                  <!-- return Item btn -->
                  <v-list-tile @click="returnInvoiceModalOpen(props.item)">
                    <v-list-tile-avatar>
                      <v-icon color="primary">assignment_return</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-title v-if="isBuyer"
                      >Credit note</v-list-tile-title
                    >
                    <v-list-tile-title v-else>Debit note</v-list-tile-title>
                  </v-list-tile>

                  <!-- View More Information -->
                  <v-list-tile
                    v-if="status.includes('due') || status.includes('partial')"
                    @click="openInvoice(props.item)"
                  >
                    <v-list-tile-avatar>
                      <v-icon color="primary">local_parking</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-title>Pay</v-list-tile-title>
                  </v-list-tile>

                  <!-- Move To Unpick Item and show only if status is open -->
                  <v-list-tile
                    v-if="status.includes('due') || status.includes('partial')"
                    @click="
                      toggleUnpick(props.item['.key'], props.item.isUnpicked)
                    "
                  >
                    <v-list-tile-avatar>
                      <v-icon color="primary">{{
                        props.item.isUnpicked
                          ? "schedule"
                          : "cancel_schedule_send"
                      }}</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-title>{{
                      props.item.isUnpicked ? "Pick" : "Unpick"
                    }}</v-list-tile-title>
                  </v-list-tile>

                  <!-- Transfer Invoice to other user -->
                  <v-list-tile
                    :disabled="!hasInvoiceTransferPermission"
                    @click="transferInvoice(props.item)"
                  >
                    <v-list-tile-avatar>
                      <v-icon color="primary">send</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-title>Transfer To</v-list-tile-title>
                  </v-list-tile>

                  <v-list-tile
                    :disabled="!hasInvoiceDeletePermission"
                    @click="deleteInvoice(props.item)"
                  >
                    <v-list-tile-avatar>
                      <v-icon color="primary">delete</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-title>Delete Invoice</v-list-tile-title>
                  </v-list-tile>

                  <v-list-tile @click="openHistory(props.item['.key'])">
                    <v-list-tile-avatar>
                      <v-icon color="primary">history</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-title>History</v-list-tile-title>
                  </v-list-tile>

                  <v-list-group :prepend-icon="'picture_as_pdf'" no-action>
                    <template v-slot:activator>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title
                            >Invoice Download</v-list-tile-title
                          >
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>

                    <v-list-tile @click="printBasicInvoice(props.item)">
                      <v-list-tile-avatar>
                        <v-icon color="primary">panorama_vertical</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-title>Basic Print</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="printInvoice4(props.item)">
                      <v-list-tile-avatar>
                        <v-icon color="primary">panorama_wide_angle</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-title> Simple Print </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="printDairyInvoice(props.item)">
                      <v-list-tile-avatar>
                        <v-icon color="primary">panorama_vertical</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-title>Theme1 Print</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="printHorizontalInvoice(props.item)">
                      <v-list-tile-avatar>
                        <v-icon color="primary">panorama_horizontal</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-title>Detailed Print</v-list-tile-title>
                    </v-list-tile>
                    <!-- <v-list-tile
                @click="printEwayType1(props.item)"
                v-if="props.item.ewayBillDetails"
              >
               <v-list-tile-avatar>
                  <v-icon color="primary">looks_one</v-icon>
                    </v-list-tile-avatar>
                <v-list-tile-title>Excessive Print</v-list-tile-title>
              </v-list-tile>
              <v-list-tile
                @click="printEwayType2(props.item)"
                v-if="props.item.ewayBillDetails"
              >
               <v-list-tile-avatar>
                          <v-icon color="primary">looks_two</v-icon>
                        </v-list-tile-avatar>
                <v-list-tile-title>Extravagent Print</v-list-tile-title>
              </v-list-tile> -->
                    <v-list-tile
                      @click="printEwayType3(props.item)"
                      v-if="props.item.ewayBillDetails"
                    >
                      <v-list-tile-avatar>
                        <v-icon color="primary">aspect_ratio</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-title>Exclusive Print</v-list-tile-title>
                    </v-list-tile>
                  </v-list-group>

                  <!-- <v-list-tile  @click="printBasicInvoice(props.item)">
                        <v-list-tile-avatar>
                          <v-icon color="primary">picture_as_pdf</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-title>Invoice Download</v-list-tile-title>
                      </v-list-tile> -->

                  <!-- <v-list-tile  @click="pushHistory(props.item)">
                        <v-list-tile-avatar>
                          <v-icon color="primary">picture_as_pdf</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-title>pushHistory</v-list-tile-title>
                      </v-list-tile> -->
                </v-list>
              </v-menu>
            </td>
            <!-- <td class="text-xs-left nowrap"><h3>{{ props.item['.key'] }}</h3></td> -->
            <!-- <td class="text-xs-left nowrap"><h3>{{ props.item.date }}</h3></td> -->
            <td class="text-xs-left nowrap">
              <h3>
                {{ new Date(props.item.date).toLocaleDateString("en-GB") }}
              </h3>
            </td>
            <td class="text-xs-left nowrap">
              <h3>{{ props.item.invoiceId || null }}</h3>
            </td>

            <td class="nowrap">
              <h3 class="text-xs-left primary--text">
                {{
                  Number.parseFloat(props.item.totalAmount || 0 | amount) ||
                  0 | amount
                }}
              </h3>
            </td>
            <td class="nowrap">
              <h3 class="text-xs-left">
                {{
                  props.item.totalAmount -
                    (props.item.roundOffAmount || 0 | amount) -
                    getGSTtotal(props.item) +
                    Number.parseFloat(props.item.discountAmount) +
                    Number.parseFloat(
                      props.item.gstOnExtraChanrges
                        ? 0
                        : -Number.parseFloat(props.item.totalExtraCharges)
                    ) || 0 | amount
                }}
              </h3>
            </td>
            <td class="nowrap">
              <h3>{{ getGSTtotal(props.item) || 0 | amount }}</h3>
            </td>

            <td class="nowrap">
              <h3 class="text-xs-left success--text">
                {{ props.item.paidAmount || 0 | amount }}
              </h3>
            </td>
            <td class="nowrap">
              <h3 class="text-xs-left error--text">
                {{ props.item.remainingAmount || 0 | amount }}
              </h3>
            </td>
            <td class="nowrap">
              <h3>{{ props.item.totalExtraCharges || 0 | amount }}</h3>
            </td>
            <td class="nowrap">
              <h3>{{ props.item.discountAmount || 0 | amount }}</h3>
            </td>
            <td class="nowrap">
              <h3 class="text-xs-left primary--text">
                {{ props.item.roundOffAmount || 0 | amount }}
              </h3>
            </td>
            <td class="nowrap">
              <h3>{{ props.item.daysSpent }}</h3>
            </td>
            <td class="nowrap">
              <h3>{{ props.item.daysLeft }}</h3>
            </td>

            <td class="text-xs-left nowrap">
              <h3>{{ props.item.status }}</h3>
            </td>
            <td class="text-xs-left nowrap">
              <h3>{{ props.item.paymentType }}</h3>
            </td>
            <td class="text-xs-left nowrap">
              <h3>{{ props.item.firm || "--" }}</h3>
            </td>
            <!-- <td class="text-xs-left nowrap"><h3>{{ props.item.transactionType }}</h3></td> -->
            <td class="text-xs-left nowrap">
              <h3>{{ props.item.gstType }}</h3>
            </td>
            <td class="nowrap">{{ props.item.placeOfSupply }}</td>
            <td class="nowrap">{{ getStaffName(props.item.soldBy) }}</td>
            <td class="text-xs-left nowrap">
              <h3>{{ props.item.parentUserName }}</h3>
            </td>
            <!-- <td v-if="header == 'TRANSACTION CLOSE' || returnedInvoices" class="text-xs-left nowrap"><h3>{{ props.item.closedDate }}</h3></td>
                <td v-if="header == 'TRANSACTION CLOSE' || returnedInvoices" class="text-xs-left nowrap"><h3>{{ props.item.parentInvoiceDate }}</h3></td> -->
            <td
              v-if="header == 'TRANSACTION CLOSE' || returnedInvoices"
              class="text-xs-left nowrap"
            >
              <h3>
                {{
                  props.item.closedDate
                    ? new Date(props.item.closedDate).toLocaleDateString(
                        "en-GB"
                      )
                    : ""
                }}
              </h3>
            </td>
            <td
              v-if="header == 'TRANSACTION CLOSE' || returnedInvoices"
              class="text-xs-left nowrap"
            >
              <h3>
                {{
                  props.item.parentInvoiceDate
                    ? new Date(props.item.parentInvoiceDate).toLocaleDateString(
                        "en-GB"
                      )
                    : ""
                }}
              </h3>
            </td>
            <td
              v-if="header == 'TRANSACTION CLOSE' || returnedInvoices"
              class="text-xs-left nowrap"
            >
              <h3>{{ props.item.noteNumber }}</h3>
            </td>
          </tr>
        </template>
        <template slot="no-data"> No Items </template>
      </v-data-table>
    </v-card-text>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
      persistent
    >
      <v-card tile style="height: fit-content">
        <v-toolbar card dark color="primary">
          <v-toolbar-title>Invoice Payment</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click.native="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <invoice-payment
          :invoices="invoices"
          :firms="firms"
          :banks="banks"
          :buyers="buyers"
          :sellers="sellers"
          :isBuyer="isBuyer"
          :selectedInvoiceId="selectedInvoiceId"
          @close="dialog = false"
          @updateInvoice="updateInvoice"
        />
        <div style="flex: 1 1 auto"></div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="transferInvoiceDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
      persistent
    >
      <v-card tile style="height: fit-content">
        <v-toolbar card dark color="primary">
          <v-toolbar-title>Transfer Invoice to Other Customer</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click.native="transferInvoiceDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container grid-list-md text-xs-center>
          <v-tabs v-model="active" color="primary" dark centered>
            <v-tab>Select Buyer</v-tab>
            <v-tab>Create Buyer</v-tab>
            <v-tab-item>
              <v-form v-if="transferTo.length > 0">
                <v-layout row wrap>
                  <v-flex md12 />
                  <v-flex md6 xs12>
                    <v-subheader>Select Buyer*</v-subheader>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      dense
                      required
                      :items="transferTo"
                      item-text="name"
                      return-object
                      v-model="transferInvoiceUser"
                      label="Select Buyer*"
                      :rules="buyerSelectRequied"
                    >
                      <template slot="selection" slot-scope="data">
                        {{ data.item.name }}
                      </template>
                      <template slot="item" slot-scope="data">
                        <v-list-tile-content>
                          <v-list-tile-title
                            v-html="`${data.item.name}, ${data.item.mobile}`"
                          />
                          <v-list-tile-sub-title
                            v-html="generateAddress(data.item)"
                          />
                        </v-list-tile-content>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-spacer />
                  <v-flex>
                    <v-btn color="primary" @click="transferInvoiceToUser"
                      >Transfer</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-form>
              <v-layout v-else>
                <v-flex>
                  <v-subheader
                    >Please create a buyer to transfer invoice...</v-subheader
                  >
                  <v-btn color="primary" @click="active = 1"
                    >Create buyer</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item>
              <buyer-info
                :firms="firms"
                :isBuyer="true"
                :buyers="buyers"
                :sellers="sellers"
                @onCreate="transferInvoiceToUserJustCreated"
              />
            </v-tab-item>
          </v-tabs>
        </v-container>
        <div style="flex: 1 1 auto"></div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="updateInvoiceDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
      persistent
    >
      <v-card tile v-if="updateInvoiceDetail" style="height: fit-content">
        <v-toolbar card dark color="primary">
          <v-toolbar-title>Update an Invoice</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click.native="updateInvoiceDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <!-- <invoice-update :invoiceDetail="updateInvoiceDetail" :buyerId="selectedBuyer" :isBuyer="isBuyer" @close="updateInvoiceDialog = false" @updateInvoice="updateInvoice"/> -->
        <div style="flex: 1 1 auto"></div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="returnInvoiceDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
      persistent
    >
      <v-card tile v-if="returnInvoiceDetail" style="height: fit-content">
        <v-toolbar card dark color="primary">
          <v-toolbar-title v-if="isBuyer">Credit Note</v-toolbar-title>
          <v-toolbar-title v-else>Debit Note</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click.native="returnInvoiceDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <invoice-return
          :invoiceDetail="returnInvoiceDetail"
          :buyerId="selectedBuyer"
          :isBuyer="isBuyer"
          @close="returnInvoiceDialog = false"
          :firms="firms"
          :banks="banks"
          :buyers="buyers"
          :sellers="sellers"
          @returnInvoice="returnInvoice"
        />
        <div style="flex: 1 1 auto"></div>
      </v-card>
    </v-dialog>
      <v-dialog v-model="passwordDialog" width="800" persistent>
        <v-card>
          <v-card-title class="headline primary--text" primary-title>
            Enter the password
            <v-spacer></v-spacer>
            <v-btn icon dark class="primary" @click="passwordDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
             <v-text-field
              v-model="password"
              type="password"
              label="Password"
              autocomplete="false"
            ></v-text-field>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
             <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteFromDialog()">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-card>
  <!-- </v-flex>
  </v-layout> -->
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import InvoicePayment from "../InvoicePayment/";
import BuyerInfo from "./BuyerInfo";
import InvoiceReturn from "../InvoiceReturn/";
import _ from "lodash";
import {
  convertToBasicInvoice,
  convertToBasicInvoiceWithoutGST,
  convertToBasicInvoiceForDairyWithoutGST,
  convertToSimpleInvoicePrint,
  convertToEwayBillType1,
  convertToEwayBillType2,
  convertToEwayBillType3,
  convertToBasicInvoiceHorizontal,
} from "../../../utils/pdfmake";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapBuyerGetters = createNamespacedHelpers("Buyer")["mapGetters"];
export default {
  components: {
    InvoicePayment,
    BuyerInfo,
    // InvoiceUpdate,
    InvoiceReturn,
  },
  props: {
    isBuyer: {
      type: Boolean,
    },
    invoices: {
      type: Array,
    },
    status: {
      type: Array,
    },
    header: {
      type: String,
    },
    buyers: {
      type: Array,
    },
    sellers: {
      type: Array,
    },
    returnedInvoices: {
      type: Boolean,
    },
  },
  data() {
    let headers = [
      { text: "Action", sortable: false, value: "" },
      // { text: 'Invoice Key', sortable: false, value: 'key' },
      { text: "Date", sortable: true, value: "date" },
      { text: "Invoice No.", sortable: false, value: "ID" },

      { text: "Total Amount", sortable: false, value: "Total" },
      { text: "Taxable Amount", sortable: false, value: "Total" },
      { text: "GST Amount", sortable: true, value: "gstValue" }, 

      { text: "Paid Amount", sortable: false, value: "Deposite" },
      { text: "Due Amount", sortable: false, value: "Remaining" },
      { text: "Extra Charge", sortable: false, value: "Total" },
      { text: "Discount", sortable: false, value: "Total" },
      { text: "Round Off", sortable: false, value: "Total" },
      { text: "Duration (in Days)", sortable: false, value: "daysSpent" },
      { text: "Days Left", sortable: true, value: "daysLeft" },
      { text: "Status", sortable: false, value: "principalValue" },
      { text: "Payment Type", sortable: true, value: "paymentType" },
      { text: "Firm", sortable: false, value: "firm" },
      // { text: 'Transaction Type', sortable: true, value: 'paymentType' },
      { text: "GST Type", sortable: true, value: "gstType" },
      { text: "Place of Supply", sortable: false, value: "Total" },
      { text: "Sold By", sortable: false, value: "Total" },
      { text: "Transferred From", sortable: false, value: "parentUserName" },
    ];
    if (this.header == "TRANSACTION CLOSE" || this.returnedInvoices) {
      headers.push({ text: "Closed Date", sortable: true, value: "gstType" });
      headers.push({
        text: "Parent Invoice Date (Credit|Debit note)",
        sortable: true,
        value: "gstType",
      });
      headers.push({
        text: "Credit|Debit note ID",
        sortable: true,
        value: "gstType",
      });
    }
    return {
      dialog: false,
      selectedInvoiceId: null,
      assetRate: [],
      remainingAmount: 0,

      updateInvoiceDialog: false,
      returnInvoiceDialog: false,
      updateInvoiceDetail: null,
      returnInvoiceDetail: null,

      transferInvoiceDialog: false,
      transferInvoiceDetail: null,
      transferInvoiceUser: null,
      active: null,
      buyerSelectRequied: [(v) => !!v || "Select Buyer To transfer invocie"],
      currentUser: null,
      password:null,
      passwordDialog : false,
      currentPasswordReference : null,
      currentPasswordMethod : null,
      headers: headers,
    };
  },
  watch: {
    updateInvoiceDialog() {
      if (this.updateInvoiceDialog === false) {
        this.updateInvoiceDetail = null;
      }
    },
    returnInvoiceDialog() {
      if (this.returnInvoiceDialog === false) {
        this.returnInvoiceDetail = null;
      }
    },
  },
  created() {
    this.$bindAsArray(
      "invoiceHistories",
      this.$root.$firebaseRefs.invoiceHistory
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "firms",
      this.$root.$firebaseRefs.firm
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    ),
      this.$bindAsArray(
        "customerDeposit",
        this.$root.$firebaseRefs.customerDeposit
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      );
    this.$bindAsArray(
      "termsAndConditions",
      this.$root.$firebaseRefs.termsAndConditions
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    ),
      this.$bindAsArray(
        "banks",
        this.$root.$firebaseRefs.account
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsObject(
        "productById",
        this.$root.$firebaseRefs.products
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsObject(
        "staff",
        this.$root.$firebaseRefs.staff
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsArray(
        "estimates",
        this.$root.$firebaseRefs.estimates
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      );
    this.$bindAsArray(
      "customerPayments",
      this.$root.$firebaseRefs.customerPayments
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "firmSettings",
      this.$root.$firebaseRefs.firmSettings
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
  },
  computed: {
    ...mapBuyerGetters(["selectedBuyer"]),
    ...mapGlobalGetters(["selectedBrand", "finYear", "roleAndPermission","brandFinYear"]),
    ...mapGlobalGetters({
      gState: "state",
    }),
    // getDepositeAmount(){
    //   this.getCurrentUserDetails();
    //   return this.currentUser && this.currentUser.remainingAmountFromDeposite;
    // },
    getBalance() {
      // return ((this.remainingAmount ? Number.parseFloat(this.remainingAmount) : 0) + (this.getDepositeAmount ? Number.parseFloat(this.getDepositeAmount) : 0))
      return this.getRemainingBalanceAmount();
    },
    hasInvoiceEditPermission() {
      console.log(this.roleAndPermission);
      if (
        this.roleAndPermission &&
        this.roleAndPermission.permissions &&
        this.roleAndPermission.permissions.length &&
        this.roleAndPermission.permissions.indexOf("INVOICE_EDIT") > -1
      ) {
        return true;
      } else {
        return false;
      }
    },
    hasInvoiceDeletePermission() {
      console.log(this.roleAndPermission);
      if (
        this.roleAndPermission &&
        this.roleAndPermission.permissions &&
        this.roleAndPermission.permissions.length &&
        this.roleAndPermission.permissions.indexOf("INVOICE_DELETE") > -1
      ) {
        return true;
      } else {
        return false;
      }
    },
    hasInvoiceTransferPermission() {
      if (
        this.roleAndPermission &&
        this.roleAndPermission.permissions &&
        this.roleAndPermission.permissions.length &&
        this.roleAndPermission.permissions.indexOf("INVOICE_TRANSFER") > -1
      ) {
        return true;
      } else {
        return false;
      }
    },
    invoiceList() {
      let result = [];
      this.remainingAmount = 0;
      if (this.invoices.length && this.finYear) {
        let filteredInvoices = this.invoices.filter((item) => {
          return (
            item["buyerId"] === this.selectedBuyer &&
            item["brand"] === this.selectedBrand &&
            this.status.includes(item["status"]) &&
            (this.returnedInvoices ? !!item["return"] : !item["return"]) &&
            item.deleted != true
          );
        });
        console.log(filteredInvoices);
        filteredInvoices = JSON.parse(JSON.stringify(filteredInvoices));
        // let currentValue = 0;
        // let absoluteValue = 0;
        filteredInvoices.forEach((element) => {
          // this.remainingAmount += element.remainingAmount ? Number.parseFloat(element.remainingAmount) : 0;
          this.remainingAmount += element.totalAmount
            ? Number.parseFloat(element.totalAmount)
            : 0;
          this.remainingAmount -= element.paidAmount
            ? Number.parseFloat(element.paidAmount)
            : 0;
          const localDate = new Date(element["date"]);
          // const localDate2 = element['parentInvoiceDate'] ? new Date(element['parentInvoiceDate']) : null;
          // const localDate3 = element['closedDate'] ? new Date(element['closedDate']) : null;
          const dt2 = new Date();
          const dt1 = localDate;
          const daysSpent = Math.floor(
            (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
              Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
              (1000 * 60 * 60 * 24)
          );
          element["dateOfInvoice"] = element["date"];
          // element['date'] = localDate.toLocaleDateString('en-GB')
          // element['parentInvoiceDate'] = localDate2 ? localDate2.toLocaleDateString('en-GB') : '';
          // element['closedDate'] = localDate3 ? localDate3.toLocaleDateString('en-GB') : '';
          element["daysLeft"] = element["duration"]  - daysSpent
            ? element["duration"] - daysSpent
            : "--";
          element["daysSpent"] = daysSpent;
          element["status"] = element["status"];
          // let time = daysSpent / 365
          let firm = this.firms.filter(
            (item) => item[".key"] == element["firm"]
          )[0];
          if (firm) {
            element["firmID"] = element["firm"];
            element["firm"] = firm["name"];
          } else {
            element["firm"] = "--";
          }

          // New Development
          element["parentUserName"] = "--";
          if (element["originalBuyerId"]) {
            element["parentUserName"] = this.buyers.filter((c) => {
              return c[".key"] === String(element["originalBuyerId"]);
            });
            if (element["parentUserName"].length > 0) {
              element["parentUserName"] = element["parentUserName"][0].name;
            } else {
              element["parentUserName"] = "--";
            }
          }
          // End of new Developemt

          result.push(element);
        });
      }
      this.remainingAmount = Number.parseFloat(this.remainingAmount).toFixed(2);
      setTimeout(() => {
            if (result.length && document.getElementById("delete-user-btn")) {
              document.getElementById("delete-user-btn").style.display = "none";
            }
      }, 1000);
      return result;
    },
    transferTo() {
      if (!this.buyers) return [];
      const buyer = [...this.buyers];
      const sellers = [...this.sellers];
      let buyerList = buyer.filter((c) => {
        // return buyer with same brand and remove current user
        return (
          c[".key"] !== this.selectedBuyer && c["brand"] === this.selectedBrand
        );
      });
      let sellerList = sellers.filter((c) => {
        // return sellers with same brand and remove current user
        return c["brand"] === this.selectedBrand;
      });
      return [...buyerList, ...sellerList];
    },
  },
  methods: {
    getRemainingBalanceAmount() {
      let filteredInvoice = this.invoiceHistories.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["buyerId"] === this.selectedBuyer &&
          //&& (item.deleted != true)
          !item["deleted"] &&
          (item["returnStatus"]
            ? item["returnStatus"] == "remaining" && item["status"] == "paid"
            : true) &&
          (item["isLatest"] != undefined ? item["isLatest"] == true : true)
      );
      let payments = this.customerPayments.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["buyerId"] === this.selectedBuyer &&
          Number.parseFloat(item["remainingAmount"]) > 0
      );

      let customerDeposit = this.customerDeposit.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["buyerId"] === this.selectedBuyer &&
          (item["type"] === "Advance" ||
            item["type"] === "Opening Balance" ||
            item["type"] === "LoanTaken" ||
            item["type"] === "LoanGiven" ||
            item["type"] === "Security")
      );

      filteredInvoice.map((item, index) => {
        //if(item.newlyCreated && (item.status === "paid" || item.status === "partial")) {
        if (
          item.newlyCreated &&
          (item.status === "paid" || item.status === "partial")
        ) {
          let newItem = JSON.parse(JSON.stringify(item));
          newItem.date = newItem.date - 1;
          newItem.transactionType = "Debit";
          newItem.paidAmount = 0;
          newItem.status = "due";
          newItem.remainingAmount = newItem.totalAmount;
          delete newItem["newlyCreated"];
          filteredInvoice.push(newItem);
        }
        if (item.closedDate) {
          filteredInvoice[index].date = item.closedDate;
        }
      });

      customerDeposit.map((deposit, index) => {
        filteredInvoice.push(deposit);
        if (
          (deposit["type"] === "LoanTaken" ||
            deposit["type"] === "LoanGiven") &&
          deposit.status == "paid" &&
          !deposit.loanTransaction
        ) {
          customerDeposit[index].status = "due";
        }
      });

      payments.map((pay) => {
        pay["type"] = "CustomerPayment";
        filteredInvoice.push(pay);
      });
      filteredInvoice.sort(function (a, b) {
        return -(new Date(b.date) - new Date(a.date));
      });

      filteredInvoice.map((item, index) => {
        filteredInvoice[index]["debit"] = this.getDebit(filteredInvoice[index]);
        filteredInvoice[index]["credit"] = this.getCredit(
          filteredInvoice[index]
        );
        if (item.isBuyer) {
          let temp = filteredInvoice[index]["credit"];
          filteredInvoice[index]["credit"] = filteredInvoice[index]["debit"];
          filteredInvoice[index]["debit"] = temp;
        }
        filteredInvoice[index]["RunningBal"] =
          Number.parseFloat(filteredInvoice[index]["debit"] || 0) -
          Number.parseFloat(filteredInvoice[index]["credit"] || 0) +
          (index == 0
            ? 0
            : Number.parseFloat(filteredInvoice[index - 1]["RunningBal"]));
      });
      //return filteredInvoice[filteredInvoice.length-1]["RunningBal"]
      return filteredInvoice && filteredInvoice.length
        ? filteredInvoice[filteredInvoice.length - 1]["RunningBal"]
        : 0;
    },
    getDebit(item) {
      if (item.type == "CustomerPayment") {
        if (!item.isBuyer) {
          return 0;
        } else {
          return item["remainingAmount"];
        }
      } else if (
        [
          "LoanTaken",
          "LoanGiven",
          "Opening Balance",
          "Advance",
          "Security",
        ].includes(item.type)
      ) {
        switch (item.type) {
          case "LoanTaken": {
            if (item.loanTransaction) {
              return 0;
            } else {
              return Number.parseFloat(item.amount);
            }
            break;
          }
          case "LoanGiven": {
            if (item.loanTransaction) {
              if (item.loanPaymentType == "interest") {
                return Number.parseFloat(item.paidInterest);
              } else {
                return Number.parseFloat(item.paidAmount);
              }
            } else {
              return 0;
            }
            break;
          }
          case "Opening Balance": {
            return item.isUserCreated ? Number.parseFloat(0) : Number.parseFloat(item.settledAmount);
            break;
          }
          case "Advance": {
            return item.isUserCreated
              ? Number.parseFloat(item.amount)
              : Number.parseFloat(0);
            break;
          }
          case "Security": {
            return item.isUserCreated
              ? Number.parseFloat(item.amount)
              : Number.parseFloat(0);
            break;
          }
        }
      } else {
        switch (item.status) {
          case "due": {
            return 0;
            break;
          }
          case "paid": {
            // return (Number.parseFloat(item['totalAmount']));
            return (
              Number.parseFloat(item["amountFromBank"]) +
              Number.parseFloat(item["amountFromCash"])
            );
            break;
          }
          case "partial": {
            return (
              Number.parseFloat(item["amountFromBank"]) +
              Number.parseFloat(item["amountFromCash"])
            );
            break;
          }
        }
      }
    },
    getCredit(item) {
      if (item.type == "CustomerPayment") {
        if (item.isBuyer) {
          return 0;
        } else {
          return item["remainingAmount"];
        }
      } else if (
        [
          "LoanTaken",
          "LoanGiven",
          "Opening Balance",
          "Advance",
          "Security",
        ].includes(item.type)
      ) {
        switch (item.type) {
          case "LoanTaken": {
            if (item.loanTransaction) {
              if (item.loanPaymentType == "interest") {
                return Number.parseFloat(item.paidInterest);
              } else {
                return Number.parseFloat(item.paidAmount);
              }
            } else {
              return 0;
            }
            break;
          }
          case "LoanGiven": {
            if (item.loanTransaction) {
              return 0;
            } else {
              return Number.parseFloat(item.amount);
            }
            break;
          }
          case "Opening Balance": {
            return item.isUserCreated
              ? Number.parseFloat(item.amount)
              : Number.parseFloat(0);
            break;
          }
          case "Advance": {
            return item.isUserCreated
              ? Number.parseFloat(0)
              : Number.parseFloat(item.settledAmount);
            break;
          }
          case "Security": {
            return item.isUserCreated
              ? Number.parseFloat(0)
              : Number.parseFloat(item.settledAmount);
            break;
          }
        }
      } else {
        switch (item.status) {
          case "due": {
            return item.totalAmount;
            break;
          }
          case "paid": {
            return 0;
            break;
          }
          case "partial": {
            return 0;
            break;
          }
        }
      }
    },
     deleteFromDialog(){
      this[this.currentPasswordMethod](this.currentPasswordReference);
    },
    deleteUser() {
      let firm = this.firms.find(i => !!i["defaultFirm"]);
      let firmSettings = this.firmSettings.find(i => i['firm'] == firm['.key']);
      let hasPassword = firmSettings && firmSettings.deleteWithPassword && !!firmSettings.deleteInvoicePassword;
      if(hasPassword && this.password != firmSettings.deleteInvoicePassword && this.passwordDialog) {
        alert("Incorrect Password")
        this.passwordDialog = false;
        this.password = null;
      } else if (hasPassword && !this.passwordDialog){
        this.passwordDialog = true;
        this.password = null;
        this.currentPasswordReference = null;
        this.currentPasswordMethod = "deleteUser";
      }
      else if (window.confirm("Do you want to Delete ?")) {
        this.passwordDialog = false;
        this.password = null;
        if (this.isBuyer) {
          this.$root.$firebaseRefs.buyer.child(this.selectedBuyer).remove();
          this.$router.push({ path: `/buyers/${-1}` });
        } else {
          this.$root.$firebaseRefs.seller.child(this.selectedBuyer).remove();
          this.$router.push({ path: `/buyers/${-1}` });
        }
      }
    },
    pushHistory(inv) {
      inv[".key"];
      let pushInv = this.invoices.filter(
        (item) => item[".key"] == inv[".key"]
      )[0];
      if (pushInv) {
        pushInv.parentInvoiceKey = inv[".key"];
        pushInv.newlyCreated = true;
        pushInv.isLatest = true;
        delete pushInv[".key"];
        this.$root.$firebaseRefs.invoiceHistory.push(pushInv);
        console.log("push");
      }
    },
    deleteInvoice(selectedInvoice) {
      let firmSettings = this.firmSettings.find(i => i['firm'] == selectedInvoice.firmID);
      let hasPassword = firmSettings && firmSettings.deleteWithPassword && !!firmSettings.deleteInvoicePassword;
      if(hasPassword && this.password != firmSettings.deleteInvoicePassword && this.passwordDialog) {
        alert("Incorrect Password")
        this.passwordDialog = false;
        this.password = null;
      } else if (hasPassword && !this.passwordDialog){
        this.passwordDialog = true;
        this.password = null;
        this.currentPasswordReference = selectedInvoice;
        this.currentPasswordMethod = "deleteInvoice";
      }
      else if (confirm("Are you sure you want to delete this invoice?")) {
        this.passwordDialog = false;
        this.password = null;
        this.$root.$firebaseRefs.invoice.child(selectedInvoice[".key"]).update(
          {
            deleted: true,
          },
          () => {
            console.info("Invoice deleted...");
          }
        );

        let invoiceHistory = this.invoiceHistories.filter(
          (item) =>
            item["brand"] == this.selectedBrand &&
            item["parentInvoiceKey"] == selectedInvoice[".key"]
        );
        invoiceHistory.map((invoice) => {
          this.$root.$firebaseRefs.invoiceHistory.child(invoice[".key"]).update(
            {
              deleted: true,
            },
            () => {
              console.info("Invoice History deleted...");
            }
          );
        });
      }
    },
    async printBasicInvoice(selectedInvoice) {
      let termsAndConditions = this.getTermsAndConditions(selectedInvoice);
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          let banks = [];
          termsAndConditions[0].bank.map((bankId) => {
            let bank = this.banks.filter((item) => item[".key"] == bankId)[0];

            bank.address = this.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [
          {
            termsAndConditions: "",
            banks: [],
          },
        ];
      }
      let firm = this.firms.filter(
        (item) => item[".key"] == selectedInvoice.firmID
      )[0];
      firm.address = this.getAddress(firm);
      this.getCurrentUserDetails();
      let customer = this.currentUser;
      customer.address = this.getAddress(customer);
      customer.stateCode = this.gState.filter(
        (item) => item.state == customer.state
      )[0].code;
      selectedInvoice["date"] = selectedInvoice["dateOfInvoice"];
      let gstInvoice = firm.GST_user && firm.GST_user == "Yes" ? true : false;
      let gstTotal = this.calculateGSTInvoice(customer, selectedInvoice);
      let productObj = {};
      if(!gstInvoice && termsAndConditions[0].isMajorUnitDisplay) {
        selectedInvoice.items.map((item)=>{
          productObj[item['productId']] =  this.productById[item['productId']];
        })
      }
      let doc = gstInvoice
        ? await convertToBasicInvoice({
            invoiceData: selectedInvoice,
            firm: firm,
            customer: customer,
            gstTotal: gstTotal,
            terms: termsAndConditions[0],
            balance : this.getBalance,
          })
        : await convertToBasicInvoiceWithoutGST({
            invoiceData: selectedInvoice,
            firm: firm,
            customer: customer,
            gstTotal: gstTotal,
            terms: termsAndConditions[0],
            balance : this.getBalance,
            productObj : productObj
          });
      pdfMake.createPdf(doc).download(this.currentUser.name);
    },

    // Start of Dairy Invoice
    async printDairyInvoice(selectedInvoice) {
      let termsAndConditions = this.getTermsAndConditions(selectedInvoice);
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          let banks = [];
          termsAndConditions[0].bank.map((bankId) => {
            let bank = this.banks.filter((item) => item[".key"] == bankId)[0];

            bank.address = this.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [
          {
            termsAndConditions: "",
            banks: [],
          },
        ];
      }
      let firm = this.firms.filter(
        (item) => item[".key"] == selectedInvoice.firmID
      )[0];
      firm.address = this.getAddress(firm);
      this.getCurrentUserDetails();
      let customer = this.currentUser;
      customer.address = this.getAddress(customer);
      customer.stateCode = this.gState.filter(
        (item) => item.state == customer.state
      )[0].code;
      selectedInvoice["date"] = selectedInvoice["dateOfInvoice"];
      let gstInvoice = firm.GST_user && firm.GST_user == "Yes" ? true : false;
      let gstTotal = this.calculateGSTInvoice(customer, selectedInvoice);
      let productObj = {};
      if(!gstInvoice && termsAndConditions[0].isMajorUnitDisplay) {
        selectedInvoice.items.map((item)=>{
          productObj[item['productId']] =  this.productById[item['productId']];
        })
      }
      let doc = gstInvoice
        ? await convertToBasicInvoice({
            invoiceData: selectedInvoice,
            firm: firm,
            customer: customer,
            gstTotal: gstTotal,
            terms: termsAndConditions[0],
            balance : this.getBalance,
          })
        : await convertToBasicInvoiceForDairyWithoutGST({
            invoiceData: selectedInvoice,
            firm: firm,
            customer: customer,
            gstTotal: gstTotal,
            terms: termsAndConditions[0],
            balance : this.getBalance,
            productObj : productObj
          });
      pdfMake.createPdf(doc).download(this.currentUser.name);
    },
    // End of Dairy Invoice

    async printHorizontalInvoice(selectedInvoice) {
      let termsAndConditions = this.getTermsAndConditions(selectedInvoice);
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          let banks = [];
          termsAndConditions[0].bank.map((bankId) => {
            let bank = this.banks.filter((item) => item[".key"] == bankId)[0];

            bank.address = this.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [
          {
            termsAndConditions: "",
            banks: [],
          },
        ];
      }
      let firm = this.firms.filter(
        (item) => item[".key"] == selectedInvoice.firmID
      )[0];
      firm.address = this.getAddress(firm);
      this.getCurrentUserDetails();
      let customer = this.currentUser;
      customer.address = this.getAddress(customer);
      customer.stateCode = this.gState.filter(
        (item) => item.state == customer.state
      )[0].code;
      selectedInvoice["date"] = selectedInvoice["dateOfInvoice"];
      let gstTotal = this.calculateGSTInvoice(customer, selectedInvoice);
      await convertToBasicInvoiceHorizontal({
        invoiceData: selectedInvoice,
        firm: firm,
        customer: customer,
        gstTotal: gstTotal,
        terms: termsAndConditions[0],
        balance : this.getBalance,
      }).then((doc) => {
        pdfMake.createPdf(doc).download(this.currentUser.name);
      });
    },
    async printInvoice4(selectedInvoice) {
      let termsAndConditions = this.getTermsAndConditions(selectedInvoice);
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          let banks = [];
          termsAndConditions[0].bank.map((bankId) => {
            let bank = this.banks.filter((item) => item[".key"] == bankId)[0];

            bank.address = this.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [
          {
            termsAndConditions: "",
            banks: [],
          },
        ];
      }
      let firm = this.firms.filter(
        (item) => item[".key"] == selectedInvoice.firmID
      )[0];
      firm.address = this.getAddress(firm);
      this.getCurrentUserDetails();
      let customer = this.currentUser;
      customer.address = this.getAddress(customer);
      customer.stateCode = this.gState.filter(
        (item) => item.state == customer.state
      )[0].code;
      let estimates = [];
      let previousDue = [];
      if (termsAndConditions[0].isPreviousDue) {
        previousDue = this.invoices.filter(
          (item) =>
            item["brand"] == this.selectedBrand &&
            item["buyerId"] == this.selectedBuyer[".key"] &&
            ["due", "partial"].includes(item["status"]) &&
            !item["deleted"] &&
            !item["return"]
        );
      }
      if (termsAndConditions[0].isEstimate) {
        estimates = this.estimates.filter(
          (item) =>
            item["brand"] == this.selectedBrand &&
            item["buyerId"] == this.selectedBuyer[".key"] &&
            ["IN PROGRESS"].includes(item["status"])
        );
      }
      selectedInvoice["date"] = selectedInvoice["dateOfInvoice"];
      let gstTotal = this.calculateGSTInvoice(customer, selectedInvoice);
      await convertToSimpleInvoicePrint({
        invoiceData: selectedInvoice,
        firm: firm,
        customer: customer,
        gstTotal: gstTotal,
        terms: termsAndConditions[0],
        previousDue: previousDue,
        estimates: estimates,
        balance : this.getBalance,
      }).then((doc) => {
        pdfMake.createPdf(doc).download(this.currentUser.name);
      });
    },
    printEwayType1(selectedInvoice) {
      let termsAndConditions = this.getTermsAndConditions(selectedInvoice);
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          let banks = [];
          termsAndConditions[0].bank.map((bankId) => {
            let bank = this.banks.filter((item) => item[".key"] == bankId)[0];

            bank.address = this.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [
          {
            termsAndConditions: "",
            banks: [],
          },
        ];
      }
      let firm = this.firms.filter(
        (item) => item[".key"] == selectedInvoice.firmID
      )[0];
      firm.address = this.getAddress(firm);
      this.getCurrentUserDetails();
      let customer = this.currentUser;
      customer.address = this.getAddress(customer);
      customer.stateCode = this.gState.filter(
        (item) => item.state == customer.state
      )[0].code;
      selectedInvoice["date"] = selectedInvoice["dateOfInvoice"];
      let gstTotal = this.calculateGSTInvoice(customer, selectedInvoice);
      let doc = convertToEwayBillType1({
        invoiceData: selectedInvoice,
        firm: firm,
        customer: customer,
        gstTotal: gstTotal,
        terms: termsAndConditions[0],
        balance : this.getBalance,
        ebillDetails: selectedInvoice.ewayBillDetails.ebillDetails,
        consignee: selectedInvoice.ewayBillDetails.consignee,
        transportationDetails:
          selectedInvoice.ewayBillDetails.transportationDetails,
      });
      pdfMake.createPdf(doc).download(selectedInvoice.invoiceId);
    },
    async printEwayType2(selectedInvoice) {
      let termsAndConditions = this.getTermsAndConditions(selectedInvoice);
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          let banks = [];
          termsAndConditions[0].bank.map((bankId) => {
            let bank = this.banks.filter((item) => item[".key"] == bankId)[0];

            bank.address = this.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [
          {
            termsAndConditions: "",
            banks: [],
          },
        ];
      }
      let firm = this.firms.filter(
        (item) => item[".key"] == selectedInvoice.firmID
      )[0];
      firm.address = this.getAddress(firm);
      this.getCurrentUserDetails();
      let customer = this.currentUser;
      customer.address = this.getAddress(customer);
      customer.stateCode = this.gState.filter(
        (item) => item.state == customer.state
      )[0].code;
      selectedInvoice["date"] = selectedInvoice["dateOfInvoice"];
      let gstTotal = this.calculateGSTInvoice(customer, selectedInvoice);
      await convertToEwayBillType2({
        invoiceData: selectedInvoice,
        firm: firm,
        customer: customer,
        gstTotal: gstTotal,
        balance : this.getBalance,
        terms: termsAndConditions[0],
        ebillDetails: selectedInvoice.ewayBillDetails.ebillDetails,
        consignee: selectedInvoice.ewayBillDetails.consignee,
        transportationDetails:
          selectedInvoice.ewayBillDetails.transportationDetails,
      }).then((doc) => {
        pdfMake.createPdf(doc).download(selectedInvoice.invoiceId);
      });
    },
    async printEwayType3(selectedInvoice) {
      let termsAndConditions = this.getTermsAndConditions(selectedInvoice);
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          let banks = [];
          termsAndConditions[0].bank.map((bankId) => {
            let bank = this.banks.filter((item) => item[".key"] == bankId)[0];

            bank.address = this.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [
          {
            termsAndConditions: "",
            banks: [],
          },
        ];
      }
      let firm = this.firms.filter(
        (item) => item[".key"] == selectedInvoice.firmID
      )[0];
      firm.address = this.getAddress(firm);
      this.getCurrentUserDetails();
      let customer = this.currentUser;
      customer.address = this.getAddress(customer);
      customer.stateCode = this.gState.filter(
        (item) => item.state == customer.state
      )[0].code;
      selectedInvoice["date"] = selectedInvoice["dateOfInvoice"];
      let gstTotal = this.calculateGSTInvoice(customer, selectedInvoice);
      await convertToEwayBillType3({
        invoiceData: selectedInvoice,
        firm: firm,
        customer: customer,
        gstTotal: gstTotal,
        terms: termsAndConditions[0],
        balance : this.getBalance,
        ebillDetails: selectedInvoice.ewayBillDetails.ebillDetails,
        consignee: selectedInvoice.ewayBillDetails.consignee,
        transportationDetails:
          selectedInvoice.ewayBillDetails.transportationDetails,
      }).then((doc) => {
        pdfMake.createPdf(doc).download(selectedInvoice.invoiceId);
      });
    },

    getTermsAndConditions(selectedInvoice) {
      return this.termsAndConditions.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["firm"] === selectedInvoice.firmID
      );
    },
    getAddress(item) {
      let address =
        (item.village ? item.village + ", " : "") +
        (item.block ? item.block + ", " : "") +
        (item.tehsil ? item.tehsil + ", " : "") +
        (item.district ? item.district + ", " : "") +
        (item.state ? item.state + ", " : "") +
        (item.country ? item.country + ", " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    calculateGSTInvoice(currentUser, invoice) {
      let SGST_val = 0;
      let CGST_val = 0;
      let IGST_val = 0;
      invoice.items &&
        invoice.items.map((item, index) => {
          SGST_val += parseFloat(item["SGST_val"]);
          CGST_val += parseFloat(item["CGST_val"]);
          IGST_val += parseFloat(item["IGST_val"]);
        });
      return { SGST_val, CGST_val, IGST_val };
    },
    openInvoice(selectedInvoice) {
      this.selectedInvoiceId = selectedInvoice[".key"];
      this.dialog = true;
    },
    getGSTtotal(item) {
      let GSTTotal = 0;
      item &&
        item.items &&
        item.items.map((item) => {
          GSTTotal += Number.parseFloat(item.GSTValue);
        });
      if(item.gstOnExtraChanrges) {
        GSTTotal += Number.parseFloat(item.totalExtraChargesGST);
      }
      return GSTTotal;
    },
    openHistory(invoiceId) {
      this.$router.push({ path: `/invoice-history/${invoiceId}` });
    },
    getStaffName(staffId) {
      let staffObj = staffId ? this.staff[staffId] : null;
      return staffObj ? staffObj.staffName : "";
    },
    toggleUnpick(selectedInvoiceId, flag = false) {
      this.$root.$firebaseRefs.invoice.child(selectedInvoiceId).update(
        {
          isUnpicked: !flag,
        },
        () => {
          console.info("completed...");
        }
      );
    },
    // open transfer invoice dialog prompt
    transferInvoice(invoice) {
      this.transferInvoiceDialog = true;
      this.transferInvoiceDetail = invoice;
      this.transferInvoiceUser = null;
    },

    updateInvoice(invoiceData) {
      console.log("Update Invoice Called");
      this.getCurrentUserDetails();
      this.manageBeforePayments(invoiceData[".key"]);
      // this.dialog = false
      console.info(invoiceData);
      const updated_at = new Date().getTime();
      // debugger
      try {
        invoiceData["items"].forEach((item, index) => {
          item["date"] = invoiceData["date"];
          if (item.id) {
            item["updated_at"] = updated_at;
            this.$root.$firebaseRefs.item.child(item["id"]).update(item, () => {
              console.info("item udpated...");
            });
          } else {
            const response = this.$root.$firebaseRefs.item.push(item, () => {
              console.info("item pushed...");
            });
            invoiceData["items"][index]["id"] = response["key"];
          }
        });
        invoiceData["updated_at"] = updated_at;
        let key = invoiceData[".key"];
        delete invoiceData[".key"];

        this.$root.$firebaseRefs.invoice.child(key).update(invoiceData, () => {
          console.info("invoice updated...");
          this.updateInvoiceDialog = false;
          if (this.dialog) this.dialog = false;
          this.managePayments(invoiceData);
        });
        invoiceData["parentInvoiceKey"] = key;
        delete invoiceData["newlyCreated"];
        if (invoiceData.isPayment) {
          delete invoiceData["newlyCreated"];
          delete invoiceData["isPayment"];
          this.$root.$firebaseRefs.invoiceHistory.push(invoiceData);
        } else {
          let letestInv = this.invoiceHistories.filter(
            (item) =>
              item["brand"] == this.selectedBrand &&
              item["isLatest"] == true &&
              item["parentInvoiceKey"] == key
          )[0];
          let latestInvKey = letestInv[".key"];
          delete letestInv[".key"];
          letestInv["isLatest"] = false;
          this.$root.$firebaseRefs.invoiceHistory
            .child(latestInvKey)
            .update(letestInv, () => {});
          invoiceData["isLatest"] = true;
          this.$root.$firebaseRefs.invoiceHistory.push(invoiceData);
        }
      } catch (e) {
        console.info("Error at update Invoice", e);
      }
    },
    managePayments(invoiceData) {
      let beforeUpdateInvoice = this.invoices.filter(
        (item) => item[".key"] === invoiceData[".key"]
      )[0];
      switch (invoiceData.paymentType) {
        case "Cash": {
          if (invoiceData.amountFromCash) {
            let firm = this.firms.filter(
              (item) => item[".key"] == invoiceData.firm
            )[0];
            if (
              firm &&
              (invoiceData.status == "paid" || invoiceData.status == "partial")
            ) {
              firm.amount = invoiceData.isBuyer
                ? Number.parseFloat(firm.amount) +
                  Number.parseFloat(invoiceData.amountFromCash)
                : Number.parseFloat(firm.amount) -
                  Number.parseFloat(invoiceData.amountFromCash);
              delete firm[".key"];
              this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
            }
          }
          break;
        }
        case "Bank Account": {
          if (invoiceData.amountFromBank) {
            let bank = this.banks.filter(
              (item) => item[".key"] == invoiceData.bank
            )[0];
            if (
              bank &&
              (invoiceData.status == "paid" || invoiceData.status == "partial")
            ) {
              bank.amount = invoiceData.isBuyer
                ? Number.parseFloat(bank.amount) +
                  Number.parseFloat(invoiceData.amountFromBank)
                : Number.parseFloat(bank.amount) -
                  Number.parseFloat(invoiceData.amountFromBank);
              delete bank[".key"];
              this.$root.$firebaseRefs.account
                .child(invoiceData.bank)
                .set(bank);
            }
          }
          break;
        }
        case "CashAndBank Account": {
          if (invoiceData.amountFromCash && invoiceData.amountFromBank) {
            let bank = this.banks.filter(
              (item) => item[".key"] == invoiceData.bank
            )[0];
            if (
              bank &&
              (invoiceData.status == "paid" || invoiceData.status == "partial")
            ) {
              bank.amount = invoiceData.isBuyer
                ? Number.parseFloat(bank.amount) +
                  Number.parseFloat(invoiceData.amountFromBank)
                : Number.parseFloat(bank.amount) -
                  Number.parseFloat(invoiceData.amountFromBank);
              delete bank[".key"];
              this.$root.$firebaseRefs.account
                .child(invoiceData.bank)
                .set(bank);
            }
            let firm = this.firms.filter(
              (item) => item[".key"] == invoiceData.firm
            )[0];
            if (
              firm &&
              (invoiceData.status == "paid" || invoiceData.status == "partial")
            ) {
              firm.amount = invoiceData.isBuyer
                ? Number.parseFloat(firm.amount) +
                  Number.parseFloat(invoiceData.amountFromCash)
                : Number.parseFloat(firm.amount) -
                  Number.parseFloat(invoiceData.amountFromCash);
              delete firm[".key"];
              this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
            }
          }
          break;
        }
      }
      this.manageProductsQuantity(invoiceData);
    },
    manageProductsQuantity(invoiceData) {
      invoiceData.items.map((item) => {
        let key = item["productId"];
        let product = this.productById[key];
        if (this.isBuyer) {
          let saleQuantity = product["saleQuantity"]
            ? product["saleQuantity"]
            : 0;
          saleQuantity = saleQuantity + Number.parseInt(item.quantity);
          product["saleQuantity"] = saleQuantity;
        } else {
          let purchaseQuantity = product["purchaseQuantity"]
            ? product["purchaseQuantity"]
            : 0;
          purchaseQuantity = purchaseQuantity + Number.parseInt(item.quantity);
          product["purchaseQuantity"] = purchaseQuantity;
        }
        let prodQuantity = product["quantity"];
        prodQuantity = this.isBuyer
          ? Number.parseInt(prodQuantity) - Number.parseInt(item.quantity)
          : Number.parseInt(prodQuantity) + Number.parseInt(item.quantity);
        delete product[".key"];
        product["quantity"] = prodQuantity;
        this.$root.$firebaseRefs.products.child(key).set(product);
      });
    },
    getCurrentUserDetails() {
      let buyer = this.buyers.filter(
        (item) => item[".key"] === this.selectedBuyer
      )[0];
      let seller = this.sellers.filter(
        (item) => item[".key"] === this.selectedBuyer
      )[0];
      this.currentUser = buyer ? buyer : seller;
      this.isBuyer = buyer && Object.keys(buyer).length != 0 ? true : false;
    },
    manageBeforePayments(key) {
      let invoiceData = this.invoices.filter((item) => item[".key"] === key)[0];
      switch (invoiceData.paymentType) {
        case "Cash": {
          if (invoiceData.amountFromCash) {
            let firm = this.firms.filter(
              (item) => item["key"] == invoiceData.firm
            )[0];
            if (
              firm &&
              (invoiceData.status == "paid" || invoiceData.status == "partial")
            ) {
              firm.amount = this.isBuyer
                ? Number.parseFloat(firm.amount) -
                  Number.parseFloat(invoiceData.amountFromCash)
                : Number.parseFloat(firm.amount) +
                  Number.parseFloat(invoiceData.amountFromCash);
              delete firm[".key"];
              this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
            }
          }
          break;
        }
        case "Bank Account": {
          if (invoiceData.amountFromBank) {
            let bank = this.banks.filter(
              (item) => item["key"] == invoiceData.bank
            )[0];
            if (
              bank &&
              (invoiceData.status == "paid" || invoiceData.status == "partial")
            ) {
              bank.amount = this.isBuyer
                ? Number.parseFloat(bank.amount) -
                  Number.parseFloat(invoiceData.amountFromBank)
                : Number.parseFloat(bank.amount) +
                  Number.parseFloat(invoiceData.amountFromBank);
              delete bank[".key"];
              this.$root.$firebaseRefs.account
                .child(invoiceData.bank)
                .set(bank);
            }
          }
          break;
        }
        case "CashAndBank Account": {
          if (invoiceData.amountFromCash && invoiceData.amountFromBank) {
            let bank = this.banks.filter(
              (item) => item["key"] == invoiceData.bank
            )[0];
            if (
              bank &&
              (invoiceData.status == "paid" || invoiceData.status == "partial")
            ) {
              bank.amount = this.isBuyer
                ? Number.parseFloat(bank.amount) -
                  Number.parseFloat(invoiceData.amountFromBank)
                : Number.parseFloat(bank.amount) +
                  Number.parseFloat(invoiceData.amountFromBank);
              delete bank[".key"];
              this.$root.$firebaseRefs.account
                .child(invoiceData.bank)
                .set(bank);
            }
            let firm = this.firms.filter(
              (item) => item["key"] == invoiceData.firm
            )[0];
            if (
              firm &&
              (invoiceData.status == "paid" || invoiceData.status == "partial")
            ) {
              firm.amount = this.isBuyer
                ? Number.parseFloat(firm.amount) -
                  Number.parseFloat(invoiceData.amountFromCash)
                : Number.parseFloat(firm.amount) +
                  Number.parseFloat(invoiceData.amountFromCash);
              delete firm[".key"];
              this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
            }
          }
          break;
        }
      }
      this.manageBeforeProductsQuantity(invoiceData);
    },
    manageBeforeProductsQuantity(invoiceData) {
      invoiceData.items.map((item) => {
        let key = item["productId"];
        let product = this.productById[key];
        if (this.isBuyer) {
          let saleQuantity = product["saleQuantity"]
            ? product["saleQuantity"]
            : 0;
          saleQuantity = saleQuantity - Number.parseInt(item.quantity);
          product["saleQuantity"] = saleQuantity;
        } else {
          let purchaseQuantity = product["purchaseQuantity"]
            ? product["purchaseQuantity"]
            : 0;
          purchaseQuantity = purchaseQuantity - Number.parseInt(item.quantity);
          product["purchaseQuantity"] = purchaseQuantity;
        }
        let prodQuantity = product["quantity"];
        prodQuantity = this.isBuyer
          ? Number.parseInt(prodQuantity) + Number.parseInt(item.quantity)
          : Number.parseInt(prodQuantity) - Number.parseInt(item.quantity);
        delete product[".key"];
        product["quantity"] = prodQuantity;
        this.$root.$firebaseRefs.products.child(key).set(product);
      });
    },

    // Transfer user to created user id
    transferInvoiceToUserJustCreated(newUserId) {
      this.__updateTranferInvoiceUser(newUserId);
    },

    // transfer user to selected user
    transferInvoiceToUser(user) {
      if (this.transferInvoiceUser) {
        console.info("update invoice to user", this.transferInvoiceUser);
        this.__updateTranferInvoiceUser(this.transferInvoiceUser[".key"]);
      } else {
        console.info("select");
      }
    },
    // handle firebase update method when updating transfer invoice user
    // 1. update buyerId with new selected user/ created user
    __updateTranferInvoiceUser(buyerId) {
      const newDetail = {
        buyerId,
      };
      if (!this.transferInvoiceDetail.originalBuyerId) {
        // add original curomerId when transferring invoice for first time
        newDetail.originalBuyerId = this.transferInvoiceDetail.buyerId;
      }
      let letestInv = this.invoiceHistories.filter(
        (item) =>
          item["brand"] == this.selectedBrand &&
          item["parentInvoiceKey"] == this.transferInvoiceDetail[".key"]
      );
      letestInv.map((invoice) => {
        this.$root.$firebaseRefs.invoiceHistory
          .child(invoice[".key"])
          .update(newDetail, () => {
            console.info("history invoice updated...");
          });
      });
      this.$root.$firebaseRefs.invoice
        .child(this.transferInvoiceDetail[".key"])
        .update(newDetail, () => {
          this.transferInvoiceUser = null;
          this.transferInvoiceDetail = null;
          this.transferInvoiceDialog = false;
          console.info("invoice updated...");
        });
      // newDetail['parentInvoiceKey'] = this.transferInvoiceDetail['.key'];
      // delete newDetail['newlyCreated']
      // this.$root.$firebaseRefs.invoiceHistory.push(newDetail);
    },

    returnInvoice(orignalInvoiceData, remainingInvoiceData, returnInvoiceData) {
      // this.getCurrentUserDetails();
      // this.manageBeforeProductsQuantity(invoiceData);
      // invoiceData['items'].forEach((item, index) => {
      //   item['date'] = invoiceData['date'];
      //   delete item['.key'];
      //   const response = this.$root.$firebaseRefs.item.push(item);
      //   invoiceData['items'][index]['id'] = response['key']
      // });
      // invoiceData['parentInvoice'] = invoiceData['.key'];
      // invoiceData['parentInvoiceKey'] = invoiceData['.key'];
      // delete invoiceData['.key'];
      // delete invoiceData['newlyCreated'];
      // this.$root.$firebaseRefs.invoiceHistory.push(invoiceData);
      // delete invoiceData['parentInvoiceKey'];
      // this.$root.$firebaseRefs.invoice.push(invoiceData);
      // this.returnInvoiceDialog = false;
      orignalInvoiceData["returnStatus"] = "orignal";
      remainingInvoiceData["returnStatus"] = "remaining";
      returnInvoiceData["returnStatus"] = "returned";
      this.payInvoice(orignalInvoiceData);
      let creditInvoice = this.createInvoice(remainingInvoiceData);
      this.createInvoice(returnInvoiceData);
      this.payInvoice(creditInvoice);
      this.returnInvoiceDialog = false;
    },
    payInvoice(invoice) {
      invoice["status"] = "paid";
      invoice["paidAmount"] = invoice.totalAmount;
      invoice["transactionType"] = "Credit";
      invoice["remainingAmount"] = 0;
      this.managePayments(invoice, false);
      const updated_at = new Date().getTime();
      try {
        invoice["items"].forEach((item, index) => {
          item["date"] = invoice["date"];
          if (item.id) {
            item["updated_at"] = updated_at;
            this.$root.$firebaseRefs.item.child(item["id"]).update(item, () => {
              console.info("item udpated...");
            });
          } else {
            const response = this.$root.$firebaseRefs.item.push(item, () => {
              console.info("item pushed...");
            });
            invoice["items"][index]["id"] = response["key"];
          }
        });
        invoice["updated_at"] = updated_at;
        let key = invoice[".key"];
        delete invoice[".key"];

        this.$root.$firebaseRefs.invoice.child(key).update(invoice, () => {
          console.info("invoice updated...");
        });
        invoice["parentInvoiceKey"] = key;
        delete invoice["newlyCreated"];
        this.$root.$firebaseRefs.invoiceHistory.push(invoice);
      } catch (e) {
        console.info("Error at update Invoice", e);
      }
    },
    createInvoice(invoiceData) {
      this.dialog = false;
      invoiceData["items"].forEach((item, index) => {
        item["date"] = invoiceData["date"];
        delete item[".key"];
        const response = this.$root.$firebaseRefs.item.push(item);
        invoiceData["items"][index]["id"] = response["key"];
      });
      delete invoiceData[".key"];
      let res = this.$root.$firebaseRefs.invoice.push(invoiceData);
      if (res.key) {
        invoiceData["parentInvoiceKey"] = res.key;
        invoiceData["newlyCreated"] = true;
        let bank = this.banks.filter(
          (item) => item[".key"] == invoiceData.bank
        )[0];
        if (invoiceData.bank && bank && bank.length) {
          invoiceData.accountNumber = bank.accountnumber;
        }
        this.$root.$firebaseRefs.invoiceHistory.push(invoiceData);
      }
      this.getCurrentUserDetails();
      this.managePaymentsCreate(invoiceData);
      this.manageProductsQuantityCreate(invoiceData);
      // this.returnInvoiceDialog = false;

      delete invoiceData["parentInvoiceKey"];
      delete invoiceData["newlyCreated"];
      invoiceData[".key"] = res.key;
      return invoiceData;
    },
    managePaymentsCreate(invoiceData) {
      switch (invoiceData.paymentType) {
        case "Cash": {
          if (invoiceData.amountFromCash) {
            let firm = this.firms.filter(
              (item) => item[".key"] == invoiceData.firm
            )[0];
            if (
              firm &&
              (invoiceData.status == "paid" || invoiceData.status == "partial")
            ) {
              firm.amount = this.isBuyer
                ? Number.parseFloat(firm.amount) +
                  Number.parseFloat(invoiceData.amountFromCash)
                : Number.parseFloat(firm.amount) -
                  Number.parseFloat(invoiceData.amountFromCash);
              delete firm[".key"];
              this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
            }
          }
          break;
        }
        case "Bank Account": {
          if (invoiceData.amountFromBank) {
            let bank = this.banks.filter(
              (item) => item[".key"] == invoiceData.bank
            )[0];
            if (
              bank &&
              (invoiceData.status == "paid" || invoiceData.status == "partial")
            ) {
              bank.amount = this.isBuyer
                ? Number.parseFloat(bank.amount) +
                  Number.parseFloat(invoiceData.amountFromBank)
                : Number.parseFloat(bank.amount) -
                  Number.parseFloat(invoiceData.amountFromBank);
              delete bank[".key"];
              this.$root.$firebaseRefs.account
                .child(invoiceData.bank)
                .set(bank);
            }
          }
          break;
        }
        case "CashAndBank Account": {
          if (invoiceData.amountFromCash && invoiceData.amountFromBank) {
            let bank = this.banks.filter(
              (item) => item[".key"] == invoiceData.bank
            )[0];
            if (
              bank &&
              (invoiceData.status == "paid" || invoiceData.status == "partial")
            ) {
              bank.amount = this.isBuyer
                ? Number.parseFloat(bank.amount) +
                  Number.parseFloat(invoiceData.amountFromBank)
                : Number.parseFloat(bank.amount) -
                  Number.parseFloat(invoiceData.amountFromBank);
              delete bank[".key"];
              this.$root.$firebaseRefs.account
                .child(invoiceData.bank)
                .set(bank);
            }
            let firm = this.firms.filter(
              (item) => item[".key"] == invoiceData.firm
            )[0];
            if (
              firm &&
              (invoiceData.status == "paid" || invoiceData.status == "partial")
            ) {
              firm.amount = this.isBuyer
                ? Number.parseFloat(firm.amount) +
                  Number.parseFloat(invoiceData.amountFromCash)
                : Number.parseFloat(firm.amount) -
                  Number.parseFloat(invoiceData.amountFromCash);
              delete firm[".key"];
              this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
            }
          }
          break;
        }
      }
    },
    manageProductsQuantityCreate(invoiceData) {
      invoiceData.items.map((item) => {
        let key = item["productId"];
        let product = this.productById[key];
        let prodQuantity = product["quantity"];
        if (this.isBuyer) {
          let saleQuantity = product["saleQuantity"]
            ? product["saleQuantity"]
            : 0;
          saleQuantity = saleQuantity + Number.parseInt(item.quantity);
          product["saleQuantity"] = saleQuantity;
        } else {
          let purchaseQuantity = product["purchaseQuantity"]
            ? product["purchaseQuantity"]
            : 0;
          purchaseQuantity = purchaseQuantity + Number.parseInt(item.quantity);
          product["purchaseQuantity"] = purchaseQuantity;
        }
        prodQuantity = this.isBuyer
          ? Number.parseInt(prodQuantity) - Number.parseInt(item.quantity)
          : Number.parseInt(prodQuantity) + Number.parseInt(item.quantity);
        delete product[".key"];
        product["quantity"] = prodQuantity;
        this.$root.$firebaseRefs.products.child(key).set(product);
      });
    },
    // return user address by generating string
    generateAddress(user) {
      let address = "";
      if (user.block) {
        address = `${user.block}`;
      }
      if (user.village) {
        address = `${address ? address + ", " : ""}${user.village}`;
      }
      if (user.tehsil) {
        address = `${address ? address + ", " : ""}${user.tehsil}`;
      }
      if (user.state) {
        address = `${address ? address + ", " : ""}${user.state}`;
      }
      return address;
    },

    editInvoiceModalOpen(invoice) {
      // this.updateInvoiceDetail = this.invoices.filter(item => item['.key'] === invoice['.key'])[0];
      // this.updateInvoiceDialog = true;
      // this.updateInvoiceDetail = this.invoices.filter(item => item['.key'] === invoice['.key'])[0];
      // this.updateInvoiceDialog = true;
      this.$router.push({ path: `/update-invoice/${invoice[".key"]}` });
    },
    returnInvoiceModalOpen(invoice) {
      this.returnInvoiceDetail = this.invoices.filter(
        (item) => item[".key"] === invoice[".key"]
      )[0];
      this.returnInvoiceDialog = true;
    },
  },
};
</script>
<style scoped>
.avatar {
  background: #8d8d8d;
  color: white;
}
</style>
<style>
.nowrap {
  white-space: nowrap;
}
table.v-table tbody tr.isUnpicked,
table.v-table tbody tr.isUnpicked:hover {
  background: rgba(0, 0, 0, 0.3) !important;
}
.absoluteMore {
  color: #dc2525;
}
</style>



// WEBPACK FOOTER //
// src/components/Buyers/Buyer/BuyerTransactions.vue